/* Presentation only: never changes Shopify variant prices, cart lines or discounts. */
(function (global) {
  'use strict';
  function ids(value) { return new Set(String(value || '').split(/[,\s]+/).filter(Boolean)); }
  function normalize(raw) {
    return { enabled: raw.enabled === true, percent: Number(raw.percent), start: Date.parse(raw.start), end: Date.parse(raw.end), products: ids(raw.products), variants: ids(raw.variants), terms: String(raw.terms || '') };
  }
  function eligible(config, productId, variantId, now) {
    return config.enabled && Number.isFinite(config.percent) && config.percent > 0 && config.percent <= 100 && Number.isFinite(config.start) && Number.isFinite(config.end) && config.end > config.start && now >= config.start && now < config.end && config.products.has(String(productId)) && config.variants.has(String(variantId));
  }
  function price(cents, percent) { return Math.round(Number(cents) * (100 - percent) / 100); }
  if (typeof module !== 'undefined' && module.exports) module.exports = { normalize: normalize, eligible: eligible, price: price };
  if (!global.document) return;
  var configNode = document.getElementById('hfc-theme-campaign-config');
  if (!configNode) return;
  var raw;
  try { raw = JSON.parse(configNode.textContent); } catch (_) { return; }
  var config = normalize(raw);
  var clockOffset = Number.isFinite(raw.serverNow) ? raw.serverNow - Date.now() : 0;
  var states = new WeakMap();
  function now() { return Date.now() + clockOffset; }
  function money(cents) {
    var format = global.MinimogSettings && global.MinimogSettings.money_format;
    if (global.Shopify && typeof global.Shopify.formatMoney === 'function' && format) return global.Shopify.formatMoney(cents, format);
    return 'kr. ' + (cents / 100).toLocaleString('da-DK', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  }
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function state(root) {
    if (!root) return null;
    var result = states.get(root);
    if (result) return result;
    var data = root.querySelector('[data-hfc-campaign-variants]');
    try { result = {variants: JSON.parse(data.textContent), selected: root.dataset.variantId, from: root.dataset.campaignCard === 'true'}; } catch (_) { return null; }
    states.set(root, result);
    return result;
  }
  function render(root) {
    var s = state(root);
    if (!s) return;
    var variant = s.variants.find(function (v) { return String(v.id) === String(s.selected); });
    var show = !!variant && eligible(config, root.dataset.productId, variant.id, now()) && Number.isFinite(variant.price) && variant.price >= 0;
    root.querySelector('[data-hfc-campaign-native]').hidden = show;
    root.querySelector('[data-hfc-campaign-offer]').hidden = !show;
    if (!show) return;
    text(root.querySelector('[data-hfc-campaign-price]'), money(price(variant.price, config.percent)));
    text(root.querySelector('[data-hfc-campaign-before]'), money(variant.price));
    text(root.querySelector('[data-hfc-campaign-saving]'), 'Spar ' + config.percent + ' %');
    text(root.querySelector('[data-hfc-campaign-terms]'), config.terms);
    var varies = new Set(s.variants.map(function (v) { return v.price; })).size > 1;
    text(root.querySelector('[data-hfc-campaign-from]'), s.from && varies ? 'Fra ' : '');
    root.dataset.variantId = String(variant.id);
  }
  function update(root, variant) {
    var s = state(root);
    if (!s || !variant) return;
    s.selected = String(variant.id); s.from = false;
    render(root);
  }
  global.HFCThemeCampaign = {
    updatePdp: update,
    updateCard: function (card, variant) { if (card) card.querySelectorAll('[data-hfc-campaign-prices]').forEach(function (root) { update(root, variant); }); }
  };
  function refresh() { document.querySelectorAll('[data-hfc-campaign-prices]').forEach(render); }
  function schedule() {
    var t = now();
    var next = [config.start, config.end].filter(function (value) { return Number.isFinite(value) && value > t; }).sort(function (a,b) {return a-b;})[0];
    if (next) setTimeout(function () { refresh(); schedule(); }, Math.min(2147483647, Math.max(1, next-t+10)));
  }
  function initialize() {
    refresh(); schedule();
    new MutationObserver(function (changes) {
      changes.forEach(function (change) { change.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('[data-hfc-campaign-prices]')) render(node);
        node.querySelectorAll('[data-hfc-campaign-prices]').forEach(render);
      }); });
    }).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
})(typeof window !== 'undefined' ? window : globalThis);
